export interface WithdrawalReceiptSettings {
    main_enabled: boolean;
    milennium_enabled: boolean;
}

export interface WithdrawalReceiptSettingsResponse {
    success: boolean;
    data: WithdrawalReceiptSettings;
}

export const withdrawalReceiptEndpoints = {
    getWithdrawalReceiptSettings: {
        query: () => "/admin/withdrawal-receipts/settings",
        providesTags: ["WithdrawalReceiptSettings"],
    },
    updateWithdrawalReceiptSettings: {
        query: (body: WithdrawalReceiptSettings) => ({
            url: "/admin/withdrawal-receipts/settings",
            method: "PUT",
            body,
        }),
        invalidatesTags: ["WithdrawalReceiptSettings"],
    },
};

export const withdrawalReceiptTags = ["WithdrawalReceiptSettings"] as const;
